import CheckDevice from '../../Modules/CheckDevice.js';
import * as CustomProperty from '../../Modules/CustomProperty.js';
import Animation from '../../Modules/Animation.js';
import DrawerMenu from '../../Modules/DrawerMenu.js';
import Modal from '../../Modules/Modal.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';
import Slider, { startAutoplayWithCustomInterval } from '../../Modules/Slider.js'; // 変更
import * as CustomScroll from '../../Modules/CustomScroll.js';
import SmoothScroll from '../../Modules/SmoothScroll.js';
import lottieAnime from '../../Modules/LottieAnime.js';
import { CircularTextAnimation } from './Modules/textAnimation.js';
import animeObj from './Modules/anime.js';
import observerManager from './Modules/observer.js';
import likeReaction from '../../Modules/LikeReaction.js';


const preinit = (e) => {
  UpdateStatus.load();
}

const init = () => {
  UpdateStatus.load();
  CheckDevice();
  CustomProperty.init();
  DrawerMenu.init();
  Modal.init();
  CustomScroll.init();
  SmoothScroll();
  Slider();
  lottieAnime.init(() => {
    startAutoplayWithCustomInterval('js-heroCarousel', 1500, 3500);
  });
  animeObj.init();
  observerManager.init();
  likeReaction.init();
}

const resize = () => {
  UpdateStatus.resize();
  CheckDevice();
  CustomProperty.resize();
  CustomScroll.resize();
}

const resizeW = () => {
  CustomProperty.resizeW();
}

const scroll = () => {
  UpdateStatus.scroll();
  CustomProperty.scroll();
  Animation();
}

const load = () => {
  UpdateStatus.load();
  Animation();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
